export const RecentItemsGetters = {
  RecentItemsList: 'RecentItemsGetters.RecentItemsList',
  RecentItemsForMenu: 'RecentItemsGetters.RecentItemsForMenu',
  RecentItemsPerPage: 'RecentItemsGetters.RecentItemsPerpage',
  RecentItemsListingOffset: 'RecentItemsGetters.RecentItemsListingOffset',
  RecentItemsFilteredRecordCount: 'RecentItemsGetters.RecentItemsFilteredRecordCount',
  SortBy: 'RecentItemsGetters.SortBy',
  SortDirection: 'RecentItemsGetters.SortDirection'
};

export const RecentItemsActions = {
  RetrieveRecentItemsForMenu: 'RecentItemsActions.RetrieveRecentItemsForMenu',
  RetrieveRecentItemsList: 'RecentItemsActions.RetrieveRecentItemsList',
  RetrieveRecentItemsFilteredRecordCount:
    'RecentItemsActions.RetrieveRecentItemsFilteredRecordCount',
  FilterRecentItems: 'RecentItemsActions.FilterRecentItems',
  SetRecentItemsSortOrder: 'RecentItemsActions.SetRecentItemsSortOrder',
  SetRecentItemsPaginationParameters: 'RecentItemsActions.SetRecentItemsPaginationParameters',
  DeleteRecentItems: 'RecentItemsActions.DeleteRecentItems'
};

export const RecentItemsMutations = {
  SetRecentItemsForMenu: 'RecentItemsMutations.SetRecentItemsForMenu',
  SetRecentItemsList: 'RecentItemsMutations.SetRecentItemsList',
  SetRecentItemsFilteredRecordCount: 'RecentItemsMutations.SetRecentItemsFilteredRecordCount',
  FilterRecentItems: 'RecentitemsMutations.FilterRecentItems',
  SetRecentItemsSortOrder: 'RecentItemsMutations.SetRecentItemsSortOrder',
  SetRecentItemsPaginationParameters: 'RecentItemsMutations.SetRecentItemsPaginationParameters',
  ResetRecentItemsPaginationOffset: 'RecentItemsMutations.ResetRecentItemsPaginationOffset'
};
